/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Notifications_Task_Reminder_TitleInputs */

const en_notifications_task_reminder_title = /** @type {(inputs: Notifications_Task_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reminder: ${i?.task}`)
};

const pt_br2_notifications_task_reminder_title = /** @type {(inputs: Notifications_Task_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lembrete: ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Reminder: {task}" |
*
* @param {Notifications_Task_Reminder_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_reminder_title = /** @type {((inputs: Notifications_Task_Reminder_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Reminder_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_reminder_title(inputs)
	return pt_br2_notifications_task_reminder_title(inputs)
});